export default "__VITE_ASSET__DppsoUAb__"